import { scroller } from "react-scroll";

export const handleScroll = (section: string) => {
  scroller.scrollTo(section, {
    spy: true,
    smooth: true,
    duration: 800,
  });
};